__turbopack_context__.v({
  "block": "DrawerModalList-module-scss-module__7a1s-a__block",
  "close": "DrawerModalList-module-scss-module__7a1s-a__close",
  "description": "DrawerModalList-module-scss-module__7a1s-a__description",
  "icon": "DrawerModalList-module-scss-module__7a1s-a__icon",
  "infoBlock": "DrawerModalList-module-scss-module__7a1s-a__infoBlock",
  "infoBlockNoBorder": "DrawerModalList-module-scss-module__7a1s-a__infoBlockNoBorder" + " " + "DrawerModalList-module-scss-module__7a1s-a__infoBlock",
  "list": "DrawerModalList-module-scss-module__7a1s-a__list",
  "listItem": "DrawerModalList-module-scss-module__7a1s-a__listItem",
  "loaderOverlay": "DrawerModalList-module-scss-module__7a1s-a__loaderOverlay",
  "remove": "DrawerModalList-module-scss-module__7a1s-a__remove",
  "title": "DrawerModalList-module-scss-module__7a1s-a__title",
});
